import { useContext } from 'react'
import { ProductContext } from '@/context'

export const useProduct = () => {
  const ctx = useContext(ProductContext)
  if (!ctx) throw new Error('useProduct must be used within a ProductProvider')
  return ctx
}
